export default __webpack_public_path__ + "static/media/screenshot15.8e667714.jpg";